import { render, staticRenderFns } from "./po-edit.vue?vue&type=template&id=87290118&"
import script from "./po-edit.vue?vue&type=script&lang=js&"
export * from "./po-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports